import React, { Component } from 'react'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import icon from '@fortawesome/fontawesome-free-regular/faSquare'
import checkedIcon from '@fortawesome/fontawesome-free-solid/faCheckSquare'

import * as Constants from '../../helpers/Constants'

class Checkbox extends Component {
  state = {
    hover: false
  }

  render() {
    const { hover } = this.state
    const {
      onClick,
      selected,
      color = Constants.WHITE_LABEL.colors.primary,
      hoverColor = Constants.WHITE_LABEL.colors.primaryHover,
      style
    } = this.props

    return (
      <a
        onMouseEnter={() => this.setState({ hover: true })}
        onMouseLeave={() => this.setState({ hover: false })}
        onClick={() => onClick()}
        style={{ backgroundColor: 'transparent', ...style }}
      >
        {
          <FontAwesomeIcon
            icon={selected ? checkedIcon : icon}
            style={{ fontSize: 26, color: hover ? hoverColor : color }}
          />
        }
      </a>
    )
  }
}

export { Checkbox }



// WEBPACK FOOTER //
// ./src/components/kevinsLegacy/Checkbox.js